export enum DataTypeEnum {
    Text = 'text',
    Number = 'number',
    Percent = 'percent',
    Currency = 'currency',
    Date = 'date',
}

export interface TableColumnDef {
    columnDef: string;
    // TODO: Required for new table
    field?: string;
    header?: string;
    sortColumnDef?: string;
    filterValue?: string; // lista elementów do wyświetlenia filtru
    filterColumnDef?: string; // wskazuje kolumnę dla której filtr powinien zadziałać, jeśli nie określo będzie szukał w columnDef
    isGeneralSearchColumn?: boolean; // określa, iż główne okienku search będzie wpływać tylko na tą kolumnę
    width?: number;
    color?: string;
    // @deprecated() Do zastąpienia przez type
    suffix?: string;
    // TODO: change to enum
    type?: string;
    dataType?: DataTypeEnum;
    tooltipEnabled?: boolean;
    tooltipDisabled?: boolean;
    digitsInfo?: string;
    showSort?: boolean;
    showSearch?: boolean;
    searchValue?: string;
    searched?: boolean;
    searchByEq?: boolean;
    filterNameProp?: string;
    additional?: boolean;
}

export interface NewTableDef {
    tableId: string;
    columns: TableColumnDef[];
}
